import PasswordInput from '../components/PasswordInput';
import { useState, useEffect } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap');
  .fp-pro * { box-sizing:border-box; }
  .fp-pro { font-family:'Sora',sans-serif; color:#1a1d2e; max-width:600px; }
  .fp-pro-title { font-size:1.35rem; font-weight:700; color:#0f1123; margin-bottom:1.5rem; }
  .fp-card { background:white; border-radius:16px; border:1px solid #e8ebf4; padding:1.5rem; margin-bottom:1rem; }
  .fp-avatar { width:64px; height:64px; border-radius:16px; background:linear-gradient(135deg,#0d9488,#0891b2); display:flex; align-items:center; justify-content:center; font-size:1.4rem; font-weight:700; color:white; margin-bottom:1rem; }
  .fp-name { font-size:1.1rem; font-weight:700; color:#0f1123; }
  .fp-role { font-size:.76rem; color:#0d9488; font-weight:600; margin-top:4px; }
  .fp-label { font-size:.68rem; font-weight:700; color:#9094a8; text-transform:uppercase; letter-spacing:.06em; margin-bottom:4px; }
  .fp-input { font-family:'Sora',sans-serif; font-size:.82rem; padding:9px 12px; border:1.5px solid #e0e4f0; border-radius:10px; background:#f8f9fc; color:#1a1d2e; outline:none; width:100%; margin-bottom:12px; }
  .fp-input:focus { border-color:#0d9488; background:white; }
  .fp-btn { display:inline-flex; align-items:center; gap:7px; padding:9px 18px; border:none; border-radius:10px; background:#0d9488; color:white; font-family:'Sora',sans-serif; font-size:.82rem; font-weight:600; cursor:pointer; }
  .fp-btn:hover { background:#0b7b71; }
  .fp-btn:disabled { opacity:.5; cursor:not-allowed; }
  .fp-section { font-size:.82rem; font-weight:600; color:#1a1d2e; margin-bottom:1rem; padding-bottom:8px; border-bottom:1px solid #f0f2f8; }
`;

const getInitials = (n='') => n.split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2)||'F';

export default function FinanceProfile() {
  const { user } = useAuth();
  const [pwForm, setPwForm] = useState({ currentPassword:'', newPassword:'', confirm:'' });
  const [pwSaving, setPwSaving] = useState(false);

  const handleChangePw = async (e) => {
    e.preventDefault();
    if (pwForm.newPassword !== pwForm.confirm) { toast.error('Passwords do not match'); return; }
    try {
      setPwSaving(true);
      await api.put('/finance/profile/password', { currentPassword: pwForm.currentPassword, newPassword: pwForm.newPassword });
      toast.success('Password changed');
      setPwForm({ currentPassword:'', newPassword:'', confirm:'' });
    } catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
    finally { setPwSaving(false); }
  };

  return (
    <div className="fp-pro"><style>{css}</style>
      <div className="fp-pro-title">My Profile</div>
      <div className="fp-card">
        <div className="fp-avatar">{getInitials(user?.name)}</div>
        <div className="fp-name">{user?.name}</div>
        <div className="fp-role">Finance Department</div>
        <div style={{fontSize:'.78rem',color:'#9094a8',marginTop:6}}>{user?.email}</div>
      </div>
      <div className="fp-card">
        <div className="fp-section">Change Password</div>
        <form onSubmit={handleChangePw}>
          {['currentPassword','newPassword','confirm'].map(k => (
            <div key={k}>
              <label className="fp-label">{k==='currentPassword'?'Current Password':k==='newPassword'?'New Password':'Confirm New Password'}</label>
              <PasswordInput className="fp-input" value={pwForm[k]} onChange={e=>setPwForm(p=>({...p,[k]:e.target.value}))} required />
            </div>
          ))}
          <button type="submit" className="fp-btn" disabled={pwSaving}>{pwSaving?'Changing…':'Change Password'}</button>
        </form>
      </div>
    </div>
  );
}